var _defs, _circle, _text, _text2, _clipPath, _mask, _text3, _text4, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAndAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.72,
    height: 124.72,
    viewBox: "0 0 124.72 124.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style736"
  }, "\n \n    .str0 {stroke:black;stroke-width:0.57px}\n    .fil0 {fill:none}\n    .fil1 {fill:black}\n    .fnt1 {font-weight:normal;font-size:13.53px;text-anchor: middle;}\n    .fnt0 {font-weight:normal;font-size:21.77px;text-anchor: middle;}\n   \n  "))), /*#__PURE__*/React.createElement("g", {
    id: "rescale_container"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil0 str0",
    cx: 62.36,
    cy: 62.36,
    r: 58.11,
    id: "plain_border"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_container"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 41.81,
    className: "fil1 fnt0",
    id: "text743"
  }, "LOGO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 65.91,
    className: "fil1 fnt0",
    id: "text745"
  }, "HERE")), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logoCrop"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 58.36,
    cx: 62.36,
    cy: 62.36
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logoMaskCrop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "77px",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_cropped_position",
    x: 4,
    y: 4,
    width: 116.72,
    height: 70.52,
    style: {
      fill: "transparent"
    },
    clipPath: "url(#logoCrop)",
    mask: "url(#logoMaskCrop)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo_position",
    x: 20.34,
    y: 20.34,
    width: 83.94,
    height: 54.52,
    style: {
      fill: "transparent"
    }
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 101.67,
    className: "award_text fil1 fnt1",
    fontSize: "31px",
    "data-max_count": 4
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 88.67,
    className: "award_text fil1 fnt1",
    "data-line_break": 5.6,
    "data-max_lines": 2,
    "data-max_length": 11.2,
    fontSize: "13.53px"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 62.36,
    y: 88.67,
    className: "award_text_display fil1 fnt1"
  }, "AWARD HERE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndAward);
export default __webpack_public_path__ + "static/media/logo-and-award.c7c594da3dfdfd43656a5114b750af6a.svg";
export { ForwardRef as ReactComponent };